module.exports = {
  siteTitle: 'Brixton Ramblers Lodge', // <title>
  manifestName: 'Brixton Ramblers',
  manifestShortName: 'BR #3347', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/brixton-ramblers-logo.png',
  // pathPrefix: `/gatsby-starter-paradigmshift/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Brixton Ramblers Lodge #3347',
  subHeading: 'Under the jurisdiction of the United Grand Lodge of England',
  // social
  socialLinks: [
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/brixtonramblers',
    },
  ],
  emailId: null,
  address: "Mark Masons Hall, 86 St. James's Street, London",
};
